const SET_USUARIO_LOGADO = (state, logado) => {
  state.logado = logado
}

export {
  SET_USUARIO_LOGADO
}



// WEBPACK FOOTER //
// ./src/store/usuario/mutations.js